/**
 * @file: 组件复制
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../cubeTree/index';
import * as UIToolkit from '../../UIToolkit/index';
import * as Toolkit from '../../toolkit/index';
import Config from '../../config/index';
import Utils from '../../utils/util';
import CodiSystem from '../../codiSystem/index';
import Clipboard from '../../clipboard/index';
import Select from '../select/index';
import { findCopyTarget } from './findCopyTarget';
import { sortCopyList } from './sortCopyList';
import { getCopyCubeIds } from './toolkit';
import { getLinkIndexListFromCopy } from '../layerGroup/groupPasteShelf';

let copyEnd: boolean = true;

// 复制
async function copy(): Promise<any> {
    if (!copyEnd) {
        UIToolkit.tips('复制中，请稍后');
        return;
    }

    let allSelected: Array<CubeId> = Select.getAll();
    if (!allSelected.length) {
        Toolkit.log({
            action: '复制',
            msgList: [
                {
                    value: '未选中组件，复制提前返回'
                }
            ]
        });
        return;
    }

    copyEnd = false;

    try {
        let copyDataList: Array<CubeCopyStoreData> = getCopyDataList(allSelected);
        let venderId: number = Config.get({
            moduleName: 'base',
            key: 'venderId'
        });
        const linkIndexList = getLinkIndexListFromCopy(getCopyCubeIds({data: copyDataList}))

        await Clipboard.set({
            type: 'cube',
            extendParams: {
                venderId,
                linkIndexList,
            },
            data: copyDataList
        });
        Toolkit.log({
            action: '复制',
            msgList: [
                {
                    name: '复制数据',
                    value: {
                        type: 'cube',
                        extendParams: {
                            venderId
                        },
                        data: copyDataList
                    }
                }
            ]
        });
    }
    catch(err) {
        UIToolkit.tips('复制失败，请重新复制');
    }

    copyEnd = true;
}

function getCopyDataList(allSelected: CubeId[]): CubeCopyStoreData[] {
    let copyTargets: Array<CubeId> = sortCopyList(findCopyTarget(allSelected));
    let copyDataList: Array<CubeCopyStoreData> = copyTargets.map((cubeId: CubeId): CubeCopyStoreData => {
        let cubeCopyData: CubeTreeData|null = CubeTree.getCubeTreeData(cubeId);
        let copyStoreData: CubeCopyStoreData = {
            cubeCopyData,
            extendParams: {
                originalCubePhysicsCoordinate: CodiSystem.getPhysicsCoordinate(cubeId)
            }
        };

        if (CubeTree.isPartition(cubeId)) {
            let spaceHeightUsed: PhysicsMeasurement = UIToolkit.layerSpaceHeightUsed(cubeId);

            copyStoreData.extendParams.spaceHeightUsed = spaceHeightUsed;
        }

        return copyStoreData;
    }).filter((cubeCopyStoreData: CubeCopyStoreData): boolean => {
        return Utils.isExist(cubeCopyStoreData.cubeCopyData);
    });

    return copyDataList;
}

export {
    copy
};
